import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Dropdown from "../../../reusables/dropdown";
import { motion } from "framer-motion";
import {
  animationValues,
  transitionValues,
} from "../../../../utils/pageTransitions";
import InputField from "../../../reusables/input";
import { get_supplier_payments } from "../../../../redux/actions/adminActions";
import { connect } from "react-redux";
import { order_payment_status, periods } from "../../../../utils/options";
import Spinner from "../../../reusables/spinner";
import Pagination from "../../../reusables/pagination";
import ConfirmModal from "../../../modals/confirmModal";

function Payments({ accessToken, getPayments, supplier_payments, selected }) {
  const [loading, setLoading] = useState(true);
  const [optionsActive, setOptions] = useState(null);
  const [payments, setPayments] = useState(supplier_payments);
  const [payment, setPayment] = useState(false);
  const [confirm, setConfirm] = useState({
    modal: false,
    data: [],
    payment: 0,
    status: "unpaid",
  });
  const token = accessToken;
  let params = {};

  useEffect(() => {
    getPayments({ token, selected, success });
  }, [selected]);

  useEffect(() => {
    setPayments(supplier_payments);
  }, [supplier_payments]);

  const success = () => {
    setLoading(false);
  };

  const [selectedTime, setTime] = useState("All dates");
  const handleSelectTime = (Item) => {
    setTime(Item);
    let filter = Item;
    setLoading(true);
    params = { ...params, ...{ filter: Item } };
    getPayments({ token, selected, success, params });
  };

  const [hasFilter, setFilter] = useState(false);
  const [selectedStatus, setStatus] = useState("Status");
  const handleFilter = (status) => {
    setStatus(status);
    params = { ...params, ...{ status: status } };
    getPayments({ token, selected, success, params });
  };

  const onPageChange = (page) => {
    setLoading(true);
    params = { ...params, ...{ page: page } };
    getPayments({ token, selected, success, params });
  };

  const handleSearch = (e) => {
    setLoading(true);
    let value = e.target.value;
    params = { ...params, ...{ search: value } };
    getPayments({ token, selected, success, params });
  };

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={animationValues}
      transition={transitionValues}
    >
      <div className="pt-3">
        <div className="spaceBetween">
          <div className="searchHolder">
            <InputField
              placeholder="Search by name, phone number or email"
              icon
              iconClass="ri-search-line"
              onChange={handleSearch}
            />
          </div>

          <div className="alignOnly pt-2">
            <Dropdown value={selectedTime} className="mx-1">
              {periods?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleSelectTime(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
            <Dropdown value={selectedStatus} className="mx-1">
              <div
                className="isClickable hoverGreen"
                onClick={() => {
                  setStatus("All");
                  setFilter(false);
                }}
              >
                <p className="sectionText px-3 py-2 mb-0">All</p>
              </div>
              {order_payment_status?.map((item) => (
                <div
                  className="isClickable hoverGreen"
                  onClick={() => handleFilter(item)}
                >
                  <p className="sectionText px-3 py-2 mb-0">{item}</p>
                </div>
              ))}
            </Dropdown>
          </div>
        </div>

        {loading ? (
          <Spinner big />
        ) : (
          <div className="sectionHeight--mid scrollable--mobile pt-4">
            {payments?.data?.length > 0 ? (
              <table className="table table__custom">
                <thead className="sectionText--small textIsGray table__head pb-2">
                  <tr className="">
                    <th className="">Order Number</th>
                    <th className="vAlign">Date</th>
                    <th className="vAlign">Total Products Cost</th>
                    <th className="vAlign">Total Handling Cost</th>
                    <th className="vAlign">Delivery Cost</th>
                    <th className="vAlign">Sub Total</th>
                    <th className="vAlign">Exch. Rate</th>
                    <th className="vAlign">Status</th>
                    <th className="vAlign">Action</th>
                  </tr>
                </thead>
                <tbody className="">
                  {payments?.data?.map((order) => (
                    <tr className="hasRadius">
                      <td className="alignOnly pt-3">
                        <input
                          type="checkbox"
                          className="isClickable"
                          name=""
                          id=""
                        />

                        <p className="mb-0  sectionText mx-2">
                          #{order.sub_order_id}
                        </p>
                      </td>

                      <td className="pt-3 vAlign">
                        <p className="mb-0  sectionText">{order.date}</p>
                      </td>

                      <td className="pt-3 vAlign">
                        <p className="mb-0  sectionText">
                          ₦{order.product_cost}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0 sectionText">
                          ₦{order.handling_cost}
                        </p>
                      </td>

                      <td className="vAlign pt-3 address">
                        <p className="mb-0 sectionText">
                          ₦{order.delivery_cost}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0  sectionText">₦{order.sub_total}</p>
                      </td>

                      <td className="vAlign pt-3">
                        <p className="mb-0  sectionText">
                          ₦{order.exchange_rate}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <p
                          className={`mb-0  tag ${
                            order.payment_status == "paid" ? "done" : "pending"
                          }`}
                        >
                          {order.payment_status}
                        </p>
                      </td>

                      <td className="vAlign pt-3">
                        <i
                          class="ri-more-line isClickable"
                          onClick={
                            optionsActive === order.id
                              ? () => setOptions(null)
                              : () => setOptions(order.id)
                          }
                        ></i>

                        {optionsActive === order.id && (
                          <div className="options">
                            <div className="caret"></div>
                            <div className="p-2 textIsBold lAlign sectionText--small">
                              <div
                                className="hasBorder--bottom pb-2"
                                onClick={() => setPayment(true)}
                              >
                                View
                              </div>
                              {order.payment_status === "paid" ? (
                                <div
                                  className="hasBorder--bottom pt-2 pb-2"
                                  onClick={() =>
                                    setConfirm({
                                      ...confirm,
                                      modal: true,
                                      data: [...confirm.data, order.id],
                                      payment: order.id,
                                      status: "unpaid",
                                    })
                                  }
                                >
                                  Mark as unpaid
                                </div>
                              ) : (
                                <div
                                  className="pt-2 pb-2"
                                  onClick={() =>
                                    setConfirm({
                                      ...confirm,
                                      modal: true,
                                      data: [...confirm.data, order.id],
                                      payment: order.id,
                                      status: "paid",
                                    })
                                  }
                                >
                                  Mark as paid
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="w-100 center sectionHeight--mid pt-4">
                <h2 className="sectionHead--small textIsBold textIsGreen">
                  No payment yet
                </h2>
              </div>
            )}
          </div>
        )}
        <div className="d-flex justify-content-end">
          <Pagination
            onChange={onPageChange}
            page={payments?.current_page}
            total={payments?.total}
            per_page={payments?.per_page}
          />
        </div>
      </div>

      <Modal show={payment} onHide={() => setPayment(false)} centered>
        <div className="sectionHeight--mid sectionText p-3">
          <div className="hasBorder--bottom">
            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Status</p>

              <div className="tag done">Paid</div>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Order ID</p>

              <p className="mb-0">68U56756</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Date</p>

              <p className="mb-0">22nd May 2021</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Order Number</p>

              <p className="mb-0">12047</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Quantity of Item</p>

              <p className="mb-0">200</p>
            </div>

            <div className="spaceBetween pt-2 pb-2">
              <p className="mb-0">Unite Price</p>

              <p className="mb-0">₦3,300.00</p>
            </div>
          </div>

          <div className="spaceBetween hasBorder--bottom pt-2 pb-2">
            <p className="mb-0">Product Total</p>

            <p className="mb-0">₦660,000.00</p>
          </div>

          <div className="spaceBetween pt-2 pb-2">
            <p className="mb-0">Handing Cost</p>

            <p className="mb-0">₦14,000.00</p>
          </div>

          <div className="spaceBetween hasBorder--bottom pt-2 pb-2">
            <p className="mb-0">Delivery Cost</p>

            <p className="mb-0">₦12,000.00</p>
          </div>

          <div className="spaceBetween hasBorder--bottom pt-2 pb-2">
            <p className="mb-0">Total Cost</p>

            <p className="mb-0">₦700,000.00</p>
          </div>
        </div>
      </Modal>

      <ConfirmModal
        show={confirm.modal}
        payment={confirm.payment}
        status={confirm.status}
        handleClose={() => {
          setConfirm({
            ...confirm,
            modal: false,
          });
        }}
      />
    </motion.div>
  );
}

const mapStateToProps = (state) => ({
  accessToken: state.admin.token,
  supplier_payments: state.admin.supplier_payments,
});

const mapDispatchToProps = (dispatch) => ({
  getPayments: (token, status, success) =>
    dispatch(get_supplier_payments(token, status, success)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payments);
